export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14740.c97b4ea6.jpg";